import React, { useContext } from 'react'
import {
  ActivityItem,
  Dialog,
  DialogFooter,
  DialogType,
  Icon,
  Link,
  PrimaryButton,
  Separator,
  Stack,
} from 'office-ui-fabric-react'
import { ExperimentOverviewEntry } from '../../Api/experiments'
import { SessionContext } from '../../Contexts/SessionContext'

export function ExperimentOverviewEntryDialog({
  experimentOverviewEntry,
  onDismiss,
}: {
  experimentOverviewEntry: ExperimentOverviewEntry
  onDismiss: () => void
}) {
  const ctok = useContext(SessionContext).ctok
  return (
    <Dialog
      hidden={false}
      onDismiss={onDismiss}
      modalProps={{
        isDarkOverlay: true,
        isBlocking: false,
      }}
      dialogContentProps={{
        type: DialogType.largeHeader,
        title: 'Experiments for ' + experimentOverviewEntry.domain,
        showCloseButton: true,
      }}
    >
      <Stack gap={8} style={{ marginTop: 30 }}>
        {experimentOverviewEntry.experiments.map((experiment) => (
          <ActivityItem
            key={experiment.id}
            activityIcon={<Icon iconName="TestBeaker" />}
            activityDescription={
              <Link
                href={`#/${ctok}/experiments/#/manage/${experiment.id}`}
                target="_blank"
                style={{
                  maxWidth: '40ch',
                  overflow: 'hidden',
                  textOverflow: 'ellipsis',
                  whiteSpace: 'nowrap',
                  display: 'inline-block',
                }}
              >
                {experiment.tag}
              </Link>
            }
          />
        ))}
      </Stack>
      <Separator />
      <DialogFooter>
        <PrimaryButton onClick={onDismiss} text="Close" />
      </DialogFooter>
    </Dialog>
  )
}
